import { call, put, takeEvery } from "redux-saga/effects"

import {
  CREATE_CCPA_REQUEST,

} from "./actionTypes"

import {
  createCCPARequestSuccess,
  createCCPARequestError,
  showToastAlert,

} from "./actions"

import {
  genericPostRequest,
} from "../../helpers/sf_backend_helper"
import { AppConfiguration } from "config"

function* onCreateCCPARequest(action) {
  try {
    const response = yield call(
      genericPostRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/ccpa_opted_out_users`,
      {
        body: JSON.stringify(action.payload),
        headers: {
          'Content-Type': 'application/json',
        },
      },
    );
    yield put(createCCPARequestSuccess(response))
    yield put(showToastAlert('API call successful!')); // dispatch the toast alert action
  } catch (error) {
    yield put(createCCPARequestError(error))
  }
}


function* QuoteFunnelsCCPASaga() {
  yield takeEvery(CREATE_CCPA_REQUEST, onCreateCCPARequest)
}

export default QuoteFunnelsCCPASaga

